module.exports = __webpack_public_path__ + "static/media/mssg_schedule_en_US.fad61002.PNG";